import type { ShowRoomPlanEventData } from "@/data/model/Table";

import { operatorEvents } from "@/operator/events/operatorEvents";

import { BaseController } from "./BaseController";

export class RoomPlanController extends BaseController {
    constructor() {
        super("room-plan");
    }

    protected onBecomeVisible(param?: ShowRoomPlanEventData) {
        operatorEvents.roomPlanController.onShown.dispatch(param);
    }

    protected onBecomeInvisible() {
        operatorEvents.roomPlanController.onHidden.dispatch();
    }
}
